import type Store from "@ember-data/store";
import type ApplicationInstance from "@ember/application/instance";
import { isTesting } from "@embroider/macros";

export function initialize(owner: ApplicationInstance): void {
  // Do not setup Image data when in testing mode
  // This should be setup with Mirage in the tests concerned
  if (isTesting()) return;

  const store = owner.lookup("service:store") as Store;

  const nephro = store.peekRecord("therapeutical-area", "nephro");
  const hepato = store.peekRecord("therapeutical-area", "hepato");
  const onco = store.peekRecord("therapeutical-area", "onco");
  const cardio = store.peekRecord("therapeutical-area", "cardio");
  const pneumo = store.peekRecord("therapeutical-area", "pneumo");

  const data = {
    KidneyGraftUltrasound: {
      ccam: ["JAQM002", "JAQM003"],
      label: "Echographie du greffon rénal",
      therapeuticalAreas: [nephro, hepato, cardio, pneumo]
    },
    AbdominalUltrasound: {
      ccam: [
        "ZCQM001",
        "ZCQM002",
        "ZCQM003",
        "ZCQM004",
        "ZCQM005",
        "ZCQM006",
        "ZCQM007",
        "ZCQM008",
        "ZCQM009",
        "ZCQM010",
        "ZCQM011"
      ],
      label: "Echographie abdominale",
      therapeuticalAreas: [nephro, hepato, cardio, pneumo]
    },
    LungUltrasound: {
      ccam: ["LJQK002", "ZBQK002"],
      label: "Radiographie du poumon",
      therapeuticalAreas: [nephro, hepato, cardio, pneumo, onco]
    },
    BoneDensitometry: {
      ccam: ["PAQK007", "PAQK008", "PAQK900"],
      label: "Densitométrie osseuse",
      therapeuticalAreas: [nephro, hepato, cardio, pneumo, onco]
    },
    CervicovaginalSmear: {
      ccam: ["JKHA001"],
      label: "Frottis cervicovaginal",
      therapeuticalAreas: [nephro, hepato, cardio, pneumo]
    },
    Mammography: {
      ccam: ["QELH001", "QEQH001", "QEQK001", "QEQK003", "QEQK004", "QEQK005"],
      label: "Mammographie",
      therapeuticalAreas: [nephro, hepato, cardio, pneumo, onco]
    },
    SupraAorticTrunksDopplerEchography: {
      ccam: [
        "DZQJ001",
        "DZQJ006",
        "DZQJ008",
        "DZQJ009",
        "DZQJ010",
        "DZQJ011",
        "DZQM005",
        "DZQM006",
        "EAQM003",
        "EAQM004",
        "EAQM005",
        "EBQM001",
        "EBQM002",
        "EBQM003",
        "EBQM900"
      ],
      label: "Echographie Doppler des TSAo (troncs supra-aortiques)",
      therapeuticalAreas: [nephro, hepato, cardio, pneumo]
    },
    LowerLimbEchography: {
      ccam: ["EJQM003"],
      label: "Echo doppler membres inférieurs",
      therapeuticalAreas: [nephro, hepato, cardio, pneumo]
    },
    ArteriovenousFistulaEchography: {
      ccam: ["EZQM001"],
      label: "Echographie de fistule artério-veineuse)",
      therapeuticalAreas: [nephro, hepato, cardio, pneumo]
    },
    MammaryMRI: {
      ccam: ["QEQJ001", "QEQN001"],
      label: "IRM mammaire",
      therapeuticalAreas: [onco]
    },
    Chest: {
      ccam: ["ZBQK002"],
      label: "Radiographie du thorax",
      therapeuticalAreas: [onco]
    },
    BoneMineralDensityTest: {
      ccam: ["PAQK007"],
      label:
        "Ostéodensitométrie [Absorptiométrie osseuse] sur 2 sites, par méthode biphotonique",
      therapeuticalAreas: [onco]
    },
    BreastUltrasound: {
      ccam: ["QEQM001"],
      label: "Échographie unilatérale ou bilatérale du sein",
      therapeuticalAreas: [onco]
    },
    Scintigraphy: {
      ccam: [
        "PAQL003",
        "PAQL001",
        "PAQL006",
        "PAQL004",
        "PAQL002",
        "PAQL007",
        "PAQL005",
        "PAQL008",
        "PAQL009",
        "PAQL010"
      ],
      label: "Scintigraphie",
      therapeuticalAreas: [onco]
    },
    TEPScan: {
      ccam: ["ZZQL016"],
      label:
        "Tomoscintigraphie du corps entier par émission de positons, avec tépographe [caméra TEP] dédié",
      therapeuticalAreas: [onco]
    },
    Scanner: {
      ccam: ["ZBQH001", "EBQH004", "ZCQH001", "ACQH004"],
      label: "Scanner",
      therapeuticalAreas: [onco]
    }
  };

  Object.entries(data).forEach(([id, { ccam, label, therapeuticalAreas }]) => {
    store.createRecord("image", {
      id,
      ccam,
      label,
      therapeuticalAreas
    });
  });
}

export default {
  after: "therapeutical-areas",
  initialize
};
